import { XMarkOctagonFillIcon } from '@navikt/aksel-icons';
import { Paragraph } from '../Paragraph';
import classes from './ErrorMessage.module.css';

type ErrorMessageProps = {
  error: string;
  size: 'sm' | 'md' | 'ml' | 'lg';
};

export const ErrorMessage = ({ error, size }: ErrorMessageProps) => {
  return (
    <div className={classes.errorMessageContainer}>
      <XMarkOctagonFillIcon
        aria-hidden
        fontSize="1.5rem"
        className={classes.icon}
      />
      <Paragraph
        size={size}
        className={classes.errorMessage}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        {error}
      </Paragraph>
    </div>
  );
};
